import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        quizzes: null,
        step: 0,
        duration: 0,
        email: '',
        name: '',
        activeQuiz: null,
        certificate: {},
        userAnswers: {},
        userName: '',
        isLoaded: false,
        hide_answers: false,
        quizData: null,
    },
    mutations: {
        fetchQuizzes(state) {
            $('.loader').addClass('show')
            axios.get('/forms/json').then(res => {
                state.quizzes = res.data
            }).catch(error => {
                console.log(error.response)
            }).finally(() => {
                $('.loader').removeClass('show')
            })
        },

        setEmail(state, payload) {
            state.email = payload;
        },
        setName(state, payload) {
            state.name = payload;
        },

        fetchQuiz(state, payload) {
            const id = typeof payload === 'object' && payload !== null ? payload.id : payload;
            const showSkeleton = typeof payload === 'object' && payload !== null ? !!payload.showSkeleton : false;

            if (!showSkeleton) {
                $('.loader').addClass('show');
            }

            axios.get(`/forms/${id}/json${window.location.search}`).then(res => {
                state.activeQuiz = res.data.form
                if (res.data.answers) {
                    const questionMapping = {};
                    for (const questionKey in state.activeQuiz.questions) {
                        const question = state.activeQuiz.questions[questionKey];
                        questionMapping[question.original_id] = question.id;
                    }

                    const qIds = state.activeQuiz.questions.map(q => Number(q.id));
                    let filteredAnswers = {};
                    for (const questionId in res.data.answers) {
                        const currentQuestionId = questionMapping[questionId];
                        if (qIds.includes(Number(currentQuestionId))) {
                            filteredAnswers[currentQuestionId] = res.data.answers[questionId];
                        }
                    }

                    state.userAnswers = filteredAnswers;
                    state.email = res.data.email;
                    state.name = res.data.name;
                } else {
                    state.userAnswers = {}
                }
            }).catch(error => {
                if (error.response.status) {
                    toastr.error(somethingWentWrongMessage)
                }
            }).finally(() => {
                $('.loader').removeClass('show');
            })
        },

        runDuration(state) {
            state.duration = 0;
            setInterval(() => {
                state.duration++;
            }, 1000)
        },

        fetchQuizReport(state, id) {
            $('.loader').addClass('show')

            axios.get(`/forms/${id}/confirm/json${window.location.search}`).then(res => {
                state.userAnswers = res.data.report.data.answers;
                state.certificate = res.data.report.certificate
                state.activeQuiz = res.data.report.form
                state.userName = res.data.report.user ? res.data.report.user.name : null;
                state.hide_answers = res.data.report.form.hide_answers;
                state.isLoaded = true;
            }).catch(error => {
                if (error.response.status) {
                    toastr.error(somethingWentWrongMessage)
                }
            }).finally(() => {
                $('.loader').removeClass('show')
            })
        },

        addUserAnswer(state, payload) {
            if (!state.userAnswers[payload.question.id]) {
                state.userAnswers[payload.question.id] = {};
                state.userAnswers[payload.question.id].answers = [];
            }

            let questionAnswer;

            for (let questionItem of state.activeQuiz.questions) {
                for (let answerItem of questionItem.answers) {
                    if (answerItem.id === +payload.answerId) {
                        questionAnswer = answerItem;
                        break;
                    }
                }
            }

            let answers = state.userAnswers[payload.question.id].answers;
            let question = payload.question;

            if (question.type !== 'multiple' && question.type !== 'file') {
                answers = []
            } else {
                answers = answers.filter(answer => {
                    return answer.id !== +payload.answerId;
                });
            }

            if (payload.add) {
                answers.push(questionAnswer);
            }

            if (!answers.length) {
                delete state.userAnswers[question.id]
            } else {
                state.userAnswers[question.id].answers = answers.filter(el => el !== null && el !== undefined);
            }
        },

        addUserTextAnswer(state, payload) {
            if (!state.userAnswers[payload.question.id]) {
                state.userAnswers[payload.question.id] = {};
                state.userAnswers[payload.question.id].answers = '';
            }

            if (payload.answerText) {
                state.userAnswers[payload.question.id].answers = payload.answerText;
            } else {
                delete state.userAnswers[payload.question.id]
            }

        },

        changeIsLoaded(state) {
            state.isLoaded = false;
        },

        changeOtherUserAnswer(state, payload) {
            if (!state.userAnswers[payload.question.id]) {
                state.userAnswers[payload.question.id] = {};
                state.userAnswers[payload.question.id].answers = [];
            }

            let answers = state.userAnswers[payload.question.id].answers;
            let question = payload.question;

            if (question.type !== 'multiple') {
                answers = []
            } else {
                answers = answers.filter(answer => {
                    return answer.type !== 'other';
                });
            }

            if (payload.add && payload.answerText) {
                answers.push({
                    question_id: question.id,
                    type: 'other',
                    title: payload.answerText,
                });
            }

            if (!answers.length) {
                delete state.userAnswers[question.id]
            } else {
                state.userAnswers[question.id].answers = answers.filter(el => el !== null && el !== undefined);
            }
        },

        changeStep(state, step) {
            if (step < 0 || step >= state.activeQuiz.questions.length) {
                return;
            }

            state.step = step
        },

        addUserFileAnswer(state, payload) {
            const userAnswers = state.userAnswers;
            if (!userAnswers[payload.question.id]) {
                userAnswers[payload.question.id] = {};
                userAnswers[payload.question.id].answers = [];
            }

            if (payload.file) {
                userAnswers[payload.question.id].answers.push(payload.file);
            }

            state.userAnswers = {...userAnswers};
        },

        removeUserFileAnswer(state, payload) {
            const userAnswers = state.userAnswers;
            userAnswers[payload.question.id].answers.splice(payload.index, 1);
            state.userAnswers = {...userAnswers};
        },
    }
})
